import { QuoteStatusesType } from "@/common/const/quote/quoteStatuses.const";
import { Tag } from "antd";

export default function QuoteStatusCell({
  status,
}: {
  status: QuoteStatusesType | undefined;
}) {
  switch (status) {
    case "Expired":
      return (
        <Tag
          color="magenta"
          bordered={false}
          className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
        >
          {status}
        </Tag>
      );
    case "Loss":
      return (
        <Tag
          color="red"
          bordered={false}
          className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
        >
          {status === "Loss" ? "Lost" : status}
        </Tag>
      );
    case "NoBid":
      return (
        <Tag
          color="purple"
          bordered={false}
          className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
        >
          {status === "NoBid" ? "No Bid" : status}
        </Tag>
      );
    case "Pending":
      return (
        <Tag
          color="blue"
          bordered={false}
          className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
        >
          {status}
        </Tag>
      );
    case "Quoted":
      return (
        <Tag
          color="lime"
          bordered={false}
          className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
        >
          {status}
        </Tag>
      );
    case "Won":
      return (
        <Tag
          color="green"
          bordered={false}
          className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
        >
          {status}
        </Tag>
      );
    default:
      return (
        <Tag
          color="orange"
          bordered={false}
          className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
        >
          No data
        </Tag>
      );
  }
}
